import Immutable from 'immutable';

import {
	createModuleState,
	createModelForState,
	webapi,
	REPORTED_EXCEPTION,
	StaticLookup,
	DateUtils,
} from 'ps-gui';
import {
	createSearchModel,
	getRawNsndTokenFilterProcessor,
} from '../utils';

const EMPTY_LIST = Immutable.List([]);
const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('Label');



export default class LabelModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new LabelModel(this.#data.setIn(name, value));
		} else {
			return new LabelModel(this.#data.set(name, value));
		}
	}

	#deleteProperty(name) {
		if (Array.isArray(name)) {
			return new LabelModel(this.#data.deleteIn(name));
		} else {
			return new LabelModel(this.#data.delete(name));
		}
	}

	#setInitialized() {
		return new LabelModel(this.#data.set('initialized', true));
	}

	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		let model = this;
		model = await model.initialize(globalContext);
		model = await model.refreshSearch(true);
		return model.#setProperty('languageTimestamp', new Date().getTime());
	}

	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}


	async openDetail(producerId, labelOwnershipId) {
		let res = await webapi.execute('/api/proc/api_labels/getlabel', {
			producerId,
			labelOwnershipId
		});
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		return this.#setProperty('detail', Immutable.fromJS(res));
	}

	setDetail(detail) {
		return this.#setProperty('detail', detail);
	}

	hideDetail() {
		return this.#setProperty('detail', null);
	}

	async refreshSearch(dontSavePreference) {
		/*		let fixedFilter = {
			status_group: STATUS_GROUPS.filter(key => statusGroupFilter.get(key))
		};*/

		let srch = this.getSearch(); //.setFixedFilter(fixedFilter);
		if (!srch) {
			return this;
		}
		srch = await srch.search(1);
		return this.setSearch(srch);
	}

	async setPartyId(partyId) {
		let model = this.#setProperty('partyId', partyId);
		let srch = model.getSearch();
		srch = srch.setFixedFilter({
			producer_id: partyId
		});
		model = model.setSearch(srch);
		return model.refreshSearch();
	}

	async initialize() {
		console.log('initialize');

		let pi = await webapi.execute('/api/proc/api_labels/getpartyinfo', {});
		if (pi === REPORTED_EXCEPTION) {
			return this;
		}
		console.log('pi = ', pi);
		let model = this.#setProperty('partyLookup', StaticLookup(Immutable.fromJS(pi.parties || [])));
		let partyId = pi?.parties[0]?.key;
		model = model.#setProperty('partyId', partyId).#setProperty('year', pi.config?.distributionPeriodId).#setProperty('isLocked', pi.config?.isLocked !== 'N');
		let startOfYear = DateUtils.parseRawDate(pi.config.distributionPeriodId + '0101'), endOfYear = DateUtils.parseRawDate(pi.config.distributionPeriodId + '1231');
		model = model.#setProperty('startOfYear', startOfYear).#setProperty('endOfYear', endOfYear).#setProperty('startOfYearStr', DateUtils.formatDate(startOfYear)).#setProperty('endOfYearStr', DateUtils.formatDate(endOfYear));
		let srch = createSearchModel('/api/dq/sv_producer_label').setEntityName('label');
		srch = srch.setFixedFilter({
			producer_id: partyId
		});
		srch = srch.setProcessFilter(getRawNsndTokenFilterProcessor(['label_name']));
		model = model.setSearch(srch).#setInitialized();
		model = await model.refreshSearch(true);
		return model;
	}

	setSearch(model) {
		return new LabelModel(this.#data.set('search', model.getState()));
	}

	getSearch() {
		return createModelForState(this.#data.get('search'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}


